import dayjs from 'dayjs'
import { FC } from 'react'

import {
  FinanceBalanceState,
  FinanceBalanceTicketType
} from '@/api/models/finance'
import { cn } from '@/app/utils'
import { Badge } from '@/components/shared/badge'
import { formatRuble } from '@/utils/number'

import {
  ticketBadgeStyles,
  ticketMainTypeName
} from '../../model/tickets.constants'
import { BalanceSummaryVariant } from '../../model/tickets.types'
import { getTicketTitle, getTicketTypeName } from '../../model/tickets.utils'

type Props = {
  ticket: FinanceBalanceTicketType
  variant: BalanceSummaryVariant
  className?: string
  useCustomTitles: boolean
}

const BalanceTicketContent: FC<Props> = ({
  ticket,
  variant,
  className,
  useCustomTitles
}) => {
  if (ticket.state === FinanceBalanceState.NotPaid) {
    return (
      <div className={className}>
        <h3 className="font-bold text-16">
          {useCustomTitles ? ticketMainTypeName[ticket.type] : ticket.name}
        </h3>
        <p className="mt-6 text-[32px] font-bold leading-[32px]">
          {formatRuble(ticket.debtSum)}
        </p>
        {ticket.payBefore && (
          <Badge
            variant="bronze"
            size="x-small"
            className={cn(
              'mt-20 opacity-60 lg:mt-8',
              ticketBadgeStyles[variant]
            )}
          >
            Срок оплаты - {dayjs(ticket.payBefore).format('DD.MM.YY')}
          </Badge>
        )}
      </div>
    )
  }

  return (
    <div className={className}>
      <h3 className="font-bold text-28 md:text-24 sm:text-20">
        {useCustomTitles ? getTicketTitle(ticket, variant) : 'Ваши счета'}
      </h3>
      <p
        className={cn(
          'font-medium text-20 lg:text-16',
          !useCustomTitles && 'font-bold'
        )}
      >
        {useCustomTitles ? getTicketTypeName(ticket, variant) : ticket.name}
      </p>
    </div>
  )
}

export default BalanceTicketContent
